module.exports = __webpack_public_path__ + "assets/img/2d19-fk.svg";